export default __webpack_public_path__ + "1fe22767e81048fc5e6f1813877481e7.jpg";